import { Subscription } from 'rxjs';
import type { Translation } from 'primeng/api';
import { LangSource } from './html-lang';

/** PrimeNG'nin burada kullanilan kismi (test icin dar arayuz). */
export interface PrimeTranslationTarget {
    setTranslation(value: Translation): void;
}

// Hafta pazar baslayan diller; digerleri pazartesi (tr, de, bg).
const SUNDAY_FIRST = new Set(['en']);

/**
 * Takvim (p-datepicker) ay/gun adlarini secili dilde uretir. Adlar tarayicinin Intl
 * verisinden gelir; ceviri dosyasina ay/gun adi yazilmaz.
 */
export function buildPrimeLocale(lang: string): Translation {
    const month = (style: 'long' | 'short') => {
        const f = new Intl.DateTimeFormat(lang, { month: style, timeZone: 'UTC' });
        return Array.from({ length: 12 }, (_, m) => cap(f.format(Date.UTC(2026, m, 15)), lang));
    };
    const day = (style: 'long' | 'short' | 'narrow') => {
        const f = new Intl.DateTimeFormat(lang, { weekday: style, timeZone: 'UTC' });
        // 2026-01-04 pazar; PrimeNG dizileri pazardan baslar.
        return Array.from({ length: 7 }, (_, d) => cap(f.format(Date.UTC(2026, 0, 4 + d)), lang));
    };
    return {
        monthNames: month('long'),
        monthNamesShort: month('short'),
        dayNames: day('long'),
        dayNamesShort: day('short'),
        // Iki harfe kirpmak tr'de belirsiz (Pz/Pa); kisa ad (Pzt, Paz) kullanilir.
        dayNamesMin: day('short'),
        firstDayOfWeek: SUNDAY_FIRST.has(lang) ? 0 : 1,
        dateFormat: SUNDAY_FIRST.has(lang) ? 'mm/dd/yy' : 'dd.mm.yy'
    };
}

/** PrimeNG takvim metinlerini secili arayuz diliyle esitler (bindHtmlLang ile ayni kalip). */
export function bindPrimeNgLocale(source: LangSource, target: PrimeTranslationTarget): Subscription {
    if (source.currentLang) {
        target.setTranslation(buildPrimeLocale(source.currentLang));
    }
    return source.onLangChange.subscribe((e) => {
        if (e.lang) {
            target.setTranslation(buildPrimeLocale(e.lang));
        }
    });
}

function cap(s: string, lang: string): string {
    return s.charAt(0).toLocaleUpperCase(lang) + s.slice(1);
}
